import { render, staticRenderFns } from "./TileConfiguration.vue?vue&type=template&id=37707d94&scoped=true"
import script from "./TileConfiguration.vue?vue&type=script&lang=js"
export * from "./TileConfiguration.vue?vue&type=script&lang=js"
import style0 from "./TileConfiguration.vue?vue&type=style&index=0&id=37707d94&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37707d94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37707d94')) {
      api.createRecord('37707d94', component.options)
    } else {
      api.reload('37707d94', component.options)
    }
    module.hot.accept("./TileConfiguration.vue?vue&type=template&id=37707d94&scoped=true", function () {
      api.rerender('37707d94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/siteSetting/general/components/TileConfiguration.vue"
export default component.exports